export default "<footer>\n<mat-icon (click)=\"openDialog()\">language</mat-icon>\n</footer>\n"